import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;

import { normalizePhoneNumber } from "@dp/common";
import { computed, makeObservable, observable, runInAction } from "mobx";
import * as yup from "yup";
var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;
var alphabetRegExp = /^[A-Z'’a-z]+$/;

var _SCHEMA = yup.object({
  updatedUserFirstName: yup.string().max(32, "Max. characters allowed are 32").min(2, "Min. 2 characters required").required("This field is mandatory"),
  newUserEmailAddress: yup.string().email("Please enter a valid email").required("Please enter a valid email"),
  confirmNewUserEmailAddress: yup.string().email("Please enter a valid email").required("Please enter a valid email").oneOf([yup.ref("newUserEmailAddress"), null], "Emails don't match"),
  updatedUserMobileNumber: yup.string().required("Please enter phone number").matches(phoneRegExp, "Phone number is not valid"),
  userLastName: yup.string() // .matches(alphabetRegExp, "Only alphabets are allowed for this field")
  .min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  userNewPassword: yup.string().required("Please enter a value"),
  userConfirmPassword: yup.string().required("Please enter a value").oneOf([yup.ref("userNewPassword"), null], "New Password and Confirm Password should be same."),
  resetPasswordEmailAddress: yup.string().email("Please enter a valid email").required("Please enter a valid email"),
  resetPasswordNewPassword: yup.string().required("Please enter a value"),
  resetPasswordConfirmNewPassword: yup.string().required("Please enter a value").oneOf([yup.ref("resetPasswordNewPassword"), null], "New Password and Confirm Password should be same."),
  userCurrentPassword: yup.string().required("Please enter a value")
});

export var UserProfileModel = (_class = /*#__PURE__*/function () {
  function UserProfileModel() {
    _classCallCheck(this, UserProfileModel);

    _initializerDefineProperty(this, "_updatedUserFirstName", _descriptor, this);

    _initializerDefineProperty(this, "_newUserEmailAddress", _descriptor2, this);

    _initializerDefineProperty(this, "_confirmNewUserEmailAddress", _descriptor3, this);

    _initializerDefineProperty(this, "_updatedUserMobileNumber", _descriptor4, this);

    _initializerDefineProperty(this, "_userLastName", _descriptor5, this);

    _initializerDefineProperty(this, "_userConfirmPassword", _descriptor6, this);

    _initializerDefineProperty(this, "_userNewPassword", _descriptor7, this);

    _initializerDefineProperty(this, "_userSecurityQuestion", _descriptor8, this);

    _initializerDefineProperty(this, "_userSecurityAnswer", _descriptor9, this);

    _initializerDefineProperty(this, "_userDobDay", _descriptor10, this);

    _initializerDefineProperty(this, "_userDobMonth", _descriptor11, this);

    _initializerDefineProperty(this, "_userDobYear", _descriptor12, this);

    _initializerDefineProperty(this, "_resetPasswordEmailAddress", _descriptor13, this);

    _initializerDefineProperty(this, "_resetPasswordNewPassword", _descriptor14, this);

    _initializerDefineProperty(this, "_resetPasswordConfirmNewPassword", _descriptor15, this);

    _initializerDefineProperty(this, "_userCurrentPassword", _descriptor16, this);

    makeObservable(this);
  }

  _createClass(UserProfileModel, [{
    key: "resetValues",
    value: function resetValues() {
      var _this = this;

      runInAction(function () {
        _this._updatedUserFirstName = "";
        _this._updatedUserMobileNumber = "";
        _this._newUserEmailAddress = "";
        _this._confirmNewUserEmailAddress = "";
        _this._userLastName = "";
        _this._userNewPassword = "";
        _this._userConfirmPassword = "";
        _this._userSecurityQuestion = "";
        _this._userSecurityAnswer = "";
        _this._userDobDay = "";
        _this._userDobMonth = "";
        _this._userDobYear = "";
        _this._resetPasswordEmailAddress = "";
        _this._resetPasswordNewPassword = "";
        _this._resetPasswordConfirmNewPassword = "";
        _this.userCurrentPassword = "";
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "updatedUserFirstName",
    get: function get() {
      return this._updatedUserFirstName;
    },
    set: function set(userFirstName) {
      var _this2 = this; // if (userFirstName && !isAlphaOrContainsSpace(userFirstName)) {
      //   return;
      // }


      runInAction(function () {
        _this2._updatedUserFirstName = userFirstName;
      });
    }
  }, {
    key: "newUserEmailAddress",
    get: function get() {
      return this._newUserEmailAddress;
    },
    set: function set(userEmailAddress) {
      var _this3 = this;

      runInAction(function () {
        _this3._newUserEmailAddress = userEmailAddress;
      });
    }
  }, {
    key: "confirmNewUserEmailAddress",
    get: function get() {
      return this._confirmNewUserEmailAddress;
    },
    set: function set(confirmUserEmailAddress) {
      var _this4 = this;

      runInAction(function () {
        _this4._confirmNewUserEmailAddress = confirmUserEmailAddress;
      });
    }
  }, {
    key: "updatedUserMobileNumber",
    get: function get() {
      return this._updatedUserMobileNumber;
    },
    set: function set(mobileNumber) {
      var _this5 = this;

      var newPhoneNumber = normalizePhoneNumber(mobileNumber, this._updatedUserMobileNumber);
      runInAction(function () {
        _this5._updatedUserMobileNumber = newPhoneNumber;
      });
    }
  }, {
    key: "userLastName",
    get: function get() {
      return this._userLastName;
    },
    set: function set(value) {
      var _this6 = this;

      runInAction(function () {
        _this6._userLastName = value;
      });
    }
  }, {
    key: "userConfirmPassword",
    get: function get() {
      return this._userConfirmPassword;
    },
    set: function set(value) {
      var _this7 = this;

      runInAction(function () {
        _this7._userConfirmPassword = value;
      });
    }
  }, {
    key: "userNewPassword",
    get: function get() {
      return this._userNewPassword;
    },
    set: function set(value) {
      var _this8 = this;

      runInAction(function () {
        _this8._userNewPassword = value;
      });
    }
  }, {
    key: "userSecurityQuestion",
    get: function get() {
      return this._userSecurityQuestion;
    },
    set: function set(value) {
      var _this9 = this;

      runInAction(function () {
        _this9._userSecurityQuestion = value;
      });
    }
  }, {
    key: "userSecurityAnswer",
    get: function get() {
      return this._userSecurityAnswer;
    },
    set: function set(value) {
      var _this10 = this;

      runInAction(function () {
        _this10._userSecurityAnswer = value;
      });
    }
  }, {
    key: "userDobDay",
    get: function get() {
      return this._userDobDay;
    },
    set: function set(value) {
      var _this11 = this;

      runInAction(function () {
        _this11._userDobDay = value;
      });
    }
  }, {
    key: "userDobMonth",
    get: function get() {
      return this._userDobMonth;
    },
    set: function set(value) {
      var _this12 = this;

      runInAction(function () {
        _this12._userDobMonth = value;
      });
    }
  }, {
    key: "userDobYear",
    get: function get() {
      return this._userDobYear;
    },
    set: function set(value) {
      var _this13 = this;

      runInAction(function () {
        _this13._userDobYear = value;
      });
    }
  }, {
    key: "resetPasswordEmailAddress",
    get: function get() {
      return this._resetPasswordEmailAddress;
    },
    set: function set(value) {
      var _this14 = this;

      runInAction(function () {
        _this14._resetPasswordEmailAddress = value;
      });
    }
  }, {
    key: "resetPasswordNewPassword",
    get: function get() {
      return this._resetPasswordNewPassword;
    },
    set: function set(value) {
      var _this15 = this;

      runInAction(function () {
        _this15._resetPasswordNewPassword = value;
      });
    }
  }, {
    key: "resetPasswordConfirmNewPassword",
    get: function get() {
      return this._resetPasswordConfirmNewPassword;
    },
    set: function set(value) {
      var _this16 = this;

      runInAction(function () {
        _this16._resetPasswordConfirmNewPassword = value;
      });
    }
  }, {
    key: "userCurrentPassword",
    get: function get() {
      return this._userCurrentPassword;
    },
    set: function set(value) {
      var _this17 = this;

      runInAction(function () {
        _this17._userCurrentPassword = value;
      });
    }
  }]);

  return UserProfileModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_updatedUserFirstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_newUserEmailAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_confirmNewUserEmailAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_updatedUserMobileNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_userLastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_userConfirmPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_userNewPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_userSecurityQuestion", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_userSecurityAnswer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_userDobDay", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_userDobMonth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_userDobYear", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_resetPasswordEmailAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_resetPasswordNewPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_resetPasswordConfirmNewPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_userCurrentPassword", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatedUserFirstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updatedUserFirstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "newUserEmailAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "newUserEmailAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmNewUserEmailAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "confirmNewUserEmailAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatedUserMobileNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updatedUserMobileNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userLastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userLastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userConfirmPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userConfirmPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userNewPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userNewPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userSecurityQuestion", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userSecurityQuestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userSecurityAnswer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userSecurityAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDobDay", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDobDay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDobMonth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDobMonth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDobYear", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDobYear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPasswordEmailAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resetPasswordEmailAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPasswordNewPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resetPasswordNewPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPasswordConfirmNewPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resetPasswordConfirmNewPassword"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userCurrentPassword", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userCurrentPassword"), _class.prototype)), _class);